var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main-content"},[_c('c-header'),_c('main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"after-leave":_vm.afterLeave}},[_c('router-view')],1),_c('c-location')],1),_c('c-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }